import icon from '../../../assets/images/rt.svg';

import useStyles from './RTIcon.styles';

export function RTIcon({ direction }) {
  const _classes = useStyles({ direction });
  return <img className={_classes.root} alt='RT icon' src={icon} />;
}
